var spinCoords = {x: 901, y: 285},
    spinTabletCoords = {x: 863 + 30, y: 300},
    spinVerticalCoords = {x:512-85, y:768 + 85},
    autoCoords = {x: 935, y: 98 + 50},
    autoTabletCoords = {x: 904 + 10, y: 98 + 88},
    autoVerticalCoords = {x:512 - 250/*512-60*/, y:768+120},
    autoNarrowCoords = {x: 904, y: 170},
    gambleCoords = {x: 904 + 10, y: 98 + 88},
    startCoords = {x: 328, y: 500},
    bottomPanelCoords = {x: 0, y: 688};


module.exports = {
    progressive_jackpot_panel: {
        position : {
            x: 33,
            y: 511,
        },
        scale : 1.0,
        coin : [ 120 - 33, 17 + 69 ],
        coin_font : 'mjp_bronze_font',
        banknotes : [ 310 - 33, 17 + 69 ],
        banknotes_font : 'mjp_green_font',
        diamonds : [ 525 - 33, 17 + 69 ],
        diamonds_font : 'mjp_white_font',
        starts : [ 760 - 33, 17 + 69 ],
        starts_font : 'mjp_gold_font',
        background : 'jp_menu_panel.png',
    },

    common: {
        font:'ui_mobile_main_font'
    },

    panels: {
        settings: {
            frame: 'settings_panel.png',
            position:
                {
                    close: {x: -935, y: 249},
                    open: {x:0, y: 249}
                },
            position_tablet:
                {
                    close: {x: -935 - 20, y: 249},
                    open: {x:0, y: 249}
                }
        },
        menu: {
            frame: 'res/common/mobile/menu_panel.jpg',
            position:
                {
                    close: {x: 0, y: 0},
                    open: {x:0, y: 0}
                }
        }
    },

    buttons: {
        spin: {
            frames:{
                normal:'spin_normal.png',
                pressed:'stop_normal.png',
                disabled:'spin_normal.png',
                hover: 'spin_normal.png'
            },
            active_area:{
                circle: {
                    x: 123,
                    y: 101,
                    r: 108
                }
            },
            position:{x:spinCoords.x, y:spinCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_spin.png',
                    pressed:'vert_stop.png',
                    disabled:'vert_spin.png',
                    hover: 'vert_spin.png'
                },
                hitArea:'circle',
                position: {x:spinVerticalCoords.x, y:spinVerticalCoords.y},
            }
        },

        collect: {
            frames:{
                normal:'collect_normal.png',
                pressed:'collect_pressed.png',
                disabled:'collect_normal.png',
                hover: 'collect_normal.png'
            },
            active_area:{
                circle: {
                    x: 123,
                    y: 101,
                    r: 108
                }
            },
            position:{x:spinCoords.x, y:spinCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_collect.png',
                    pressed:'vert_collect_pressed.png',
                    disabled:'vert_collect.png',
                    hover: 'vert_collect.png'
                },
                hitArea:'circle',
                position: {x:spinVerticalCoords.x, y:spinVerticalCoords.y}
            }
        },

        stop: {
            frames:{
                normal:'stop_normal.png',
                pressed:'stop_normal.png',
                disabled:'spin_normal.png',
                hover: 'stop_normal.png'
            },
            active_area:{
                circle: {
                    x: 123,
                    y: 101,
                    r: 108
                }
            },
            position:{x:spinCoords.x, y:spinCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_stop.png',
                    pressed:'vert_stop.png',
                    disabled:'vert_spin.png',
                    hover: 'vert_stop.png'
                },
                hitArea:'circle',
                position: {x:spinVerticalCoords.x, y:spinVerticalCoords.y}
            }
        },

        start: {
            frames:{
                normal:'start_normal.png',
                pressed:'start_pressed.png',
                disabled:'start_normal.png',
                hover: 'start_normal.png'
            },
            position:{x:startCoords.x, y:startCoords.y}
        },

        finish: {
            frames:{
                normal:'finish_normal.png',
                pressed:'finish_pressed.png',
                disabled:'finish_normal.png',
                hover: 'finish_normal.png'
            },
            position:{x:startCoords.x, y:startCoords.y}
        },

        userMenu: {
            frames:{
                normal:'user_menu_disabled.png',
                pressed:'user_menu_pressed.png',
                disabled:'user_menu_disabled.png',
                hover: 'user_menu_normal.png'
            },
            hitArea:'circle',
            position:{x:917, y:604},
            position_vertical:{x:917, y:autoVerticalCoords.y + 10},
        },

        bonus_sound_on: {
            frames:{
                normal:'bonus_sound_off.png',
                pressed:'bonus_sound_off.png',
                disabled:'bonus_sound_off.png',
                hover: 'bonus_sound_off.png'
            },
            hitArea:'circle',
            position:{x:917, y:604},
            position_vertical:{x:917, y:autoVerticalCoords.y + 10},
        },

        bonus_sound_off: {
            frames:{
                normal:'bonus_sound_on.png',
                pressed:'bonus_sound_on.png',
                disabled:'bonus_sound_on.png',
                hover: 'bonus_sound_on.png'
            },
            hitArea:'circle',
            position:{x:917, y:604},
            position_vertical:{x:917, y:autoVerticalCoords.y + 10},
        },

        info: {
            frames:{
                normal:'info_button.png',
                pressed:'info_button.png',
                disabled:'info_button_disabled.png',
                hover: 'info_button.png'
            },
            hitArea:'circle',
            position:{x:224, y:320},
            location: "menu"
        },

        sound_on: {
            frames:{
                normal:'sound_off.png',
                pressed:'sound_off.png',
                disabled:'sound_off.png',
                hover: 'sound_off.png'
            },
            hitArea:'circle',
            position:{x:667, y:320},
            location: "menu"
        },

        sound_off: {
            frames:{
                normal:'sound_on.png',
                pressed:'sound_on.png',
                disabled:'sound_on.png',
                hover: 'sound_on.png'
            },
            hitArea:'circle',
            position:{x:667, y:320},
            location: "menu"
        },

        vertical: {
            frames:{
                normal:'vertical.png',
                pressed:'vertical_active.png',
                disabled:'vertical_active.png',
                hover: 'vertical.png'
            },
            hitArea:'circle',
            position:{x:148, y:97},
            location: "menu"
        },

        horizontal: {
            frames:{
                normal:'horizontal.png',
                pressed:'horizontal_active.png',
                disabled:'horizontal_active.png',
                hover: 'horizontal.png'
            },
            hitArea:'circle',
            position:{x:300, y:97},
            location: "menu"
        },

        wide: {
            frames:{
                normal:'wide.png',
                pressed:'wide_active.png',
                disabled:'wide_active.png',
                hover: 'wide.png'
            },
            hitArea:'circle',
            position:{x:592, y:97},
            location: "menu"
        },

        narrow: {
            frames:{
                normal:'narrow.png',
                pressed:'narrow_active.png',
                disabled:'narrow_active.png',
                hover: 'narrow.png'
            },
            hitArea:'circle',
            position:{x:743, y:97},
            location: "menu"
        },

        close_menu: {
            frames:{
                normal:'menu_exit.png',
                pressed:'menu_exit.png',
                disabled:'menu_exit.png',
                hover: 'menu_exit.png'
            },
            hitArea:'circle',
            position:{x:5, y:5},
            location: "menu"
        },

        gamble: {
            frames:{
                normal:'gamble_normal.png',
                pressed:'gamble_pressed.png',
                disabled:'gamble_normal.png',
                hover: 'gamble_normal.png'
            },
            active_area:{
                circle: {
                    x: 90,
                    y: 65,
                    r: 86
                }
            },
            position:{x:autoCoords.x, y:autoCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_gamble.png',
                    pressed:'vert_gamble_pressed.png',
                    disabled:'vert_gamble.png',
                    hover: 'vert_gamble.png'
                },
                hitArea:'circle',
                position: {x:autoVerticalCoords.x, y:autoVerticalCoords.y}
            }
        },

        autoplay: {
            frames:{
                normal:'autoplay_normal.png',
                pressed:'autoplay_off_normal.png',
                disabled:'autoplay_normal.png',
                hover: 'autoplay_normal.png'
            },
            active_area:{
                circle: {
                    x: 90,
                    y: 65,
                    r: 86
                }
            },
            position:{x:autoCoords.x, y:autoCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_autoplay_normal.png',
                    pressed:'vert_autoplay_off.png',
                    disabled:'vert_autoplay_normal.png',
                    hover: 'vert_autoplay_normal.png'
                },
                hitArea:'circle',
                position: {x:autoVerticalCoords.x, y:autoVerticalCoords.y}
            }
        },

        autoplayoff: {
            frames:{
                normal:'autoplay_off_normal.png',
                pressed:'autoplay_off_pressed.png',
                disabled:'autoplay_off_normal.png',
                hover: 'autoplay_off_normal.png'
            },
            active_area:{
                circle: {
                    x: 90,
                    y: 65,
                    r: 86
                }
            },
            position:{x:autoCoords.x, y:autoCoords.y},
            verticalButton: {
                frames:{
                    normal:'vert_autoplay_off.png',
                    pressed:'vert_autoplay_off.png',
                    disabled:'vert_autoplay_off.png',
                    hover: 'vert_autoplay_off.png'
                },
                hitArea:'circle',
                position: {x:autoVerticalCoords.x, y:autoVerticalCoords.y}
            }
        },

        bet_open: {
            frames:{
                normal:'bet_open.png',
                pressed:'bet_open.png',
                disabled:'bet_open.png',
                hover: 'bet_open.png'
            },
            hitArea:'circle',
            position:{x:512+130, y:autoVerticalCoords.y},
            position_vertical:{x:512+130, y:autoVerticalCoords.y}
        },

        bet_close: {
            frames:{
                normal:'bet_close.png',
                pressed:'bet_close.png',
                disabled:'bet_close.png',
                hover: 'bet_close.png'
            },
            hitArea:'circle',
            position:{x:512+130, y:autoVerticalCoords.y},
            position_vertical:{x:512+130, y:autoVerticalCoords.y}
        },

        menu: {
            frames:{
                normal:'menu_disabled.png',
                pressed:'menu_pressed.png',
                disabled:'menu_disabled.png',
                hover: 'menu_normal.png'
            },
            hitArea:'circle',
            position:{x: 5, y: 604},
            position_vertical:{x:5, y:autoVerticalCoords.y + 10},
        },

        settings_open: {
            frames:{
                normal:'open_settings.png',
                pressed:'open_settings.png',
                disabled:'open_settings.png',
                hover: 'open_settings.png'
            },
            position:{x:934, y:55},
            location: "settings"
        },

        settings_close: {
            frames:{
                normal:'close_settings.png',
                pressed:'close_settings.png',
                disabled:'close_settings.png',
                hover: 'close_settings.png'
            },
            //hitArea:'ellipse',
            position:{x:934, y:55},
            location: "settings"
        },

        betmax: {
            frames:{
                normal:'bet_max_normal.png',
                pressed:'bet_max_pressed.png',
                disabled:'bet_max_normal.png',
                hover: 'bet_max_normal.png'
            },
            //hitArea:'ellipse',
            position:{x:692, y:72},
            location: "settings"
        },

        betmin: {
            frames:{
                normal:'bet_min_normal.png',
                pressed:'bet_min_pressed.png',
                disabled:'bet_min_normal.png',
                hover: 'bet_min_normal.png'
            },
            position:{x:692, y:72},
            location: "settings"
        },
        decrease_lines: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_normal.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:-8 + 34, y:51 + 34},
            location: "settings"
        },

        increase_lines: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_normal.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:201 + 34, y:51 + 34},
            location: "settings"
        },

        decrease_linebet: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_normal.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:335 + 32, y:51 + 34},
            location: "settings"
        },

        increase_linebet: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_normal.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:545 + 26, y:51 + 34},
            location: "settings"
        },

        next: {
            frames: {
                normal:"next_normal.png",
                hover: 'next_hover.png',
                pressed:"next_pressed.png",
                disabled:"next_disabled.png"
            },
            position:{x:821,y:768-70}
        },
        exit: {
            frames: {
                normal:'menu_exit.png',
                pressed:'menu_exit.png',
                disabled:'menu_exit.png',
                hover: 'menu_exit.png'
            },
            hitArea:'circle',
            position:{x:5, y:5}
        },
        back: {
            frames: {
                normal:"back_normal.png",
                hover: 'back_hover.png',
                pressed:"back_pressed.png",
                disabled:"back_disabled.png"
            },
            position:{x:17, y:768-70}
        },
    },

    frames: {

        lines:{
            frame:'',
            font: 'ui_mobile_panel_font',
            text_position:{x:0, y:0},
            text_align:{x:0.5, y:0.5},
            position:{x:186, y:101 + 20},
            location: "settings"
        },

        line_bet:{
            frame:'',
            font: 'ui_mobile_panel_font',
            text_position:{x:0, y:0},
            text_align:{x:0.5,y:0.5},
            position:{x:525, y:101 + 20},
            location: "settings"
        },

        win:{
            frame:'win_frame.png',
            font: 'ui_mobile_win_font',
            text_position:{x:512, y:12+21+10},
            text_align:{x:0.5, y:0.5},
            position:{x:bottomPanelCoords.x, y:bottomPanelCoords.y}
        },

        credits:{
            frame:'',
            text_position:{x:0, y:0},
            text_align:{x:0.0, y:0.5},
            position:{x:bottomPanelCoords.x + 85, y:bottomPanelCoords.y + 38 + 10}
        },

        total_bet:{
            frame:'',
            text_position:{x:0, y:0},
            text_align:{x:1.0, y:0.5},
            position:{x:bottomPanelCoords.x + 956, y:bottomPanelCoords.y + 38 + 10}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/library/cfg/userinterface_mobile-config.js
// module id = 93
// module chunks = 0